import React, {
  useEffect,
  useState,
} from 'react'

import Span from './styles'

import { Props } from './types'

const Error: React.FC<Props> = ({
  active,
  alwaysShowError,
  children,
  dirty,
  delay,
  touched,
}): React.ReactElement | null => {
  const [
    show,
    setShow,
  ] = useState(false)

  useEffect(() => {
    let timeout: number
    if (active && dirty) {
      timeout = setTimeout(() => setShow(true), delay)
    }

    return (): void => {
      if (active && dirty) {
        setShow(false)
      }

      clearTimeout(timeout)
    }
  }, [
    delay,
    dirty,
    active,
  ])

  const mergedShow = (dirty && show) || alwaysShowError || false

  if (!((touched && !active) || (touched && !show && active) || mergedShow)) {
    return null // eslint-disable-line no-null/no-null
  }

  return <Span>{children}</Span>
}

export default Error
